import CompraProdutoModal from './CompraProdutoModal';

export default CompraProdutoModal;
